export enum ANNULUS_CONDITION {
  MULTIPLE = 'MULTIPLE',
  DRY = 'DRY',
  FLOODED = 'FLOODED',
}
